import { useState } from "react";
import { TESTIMONIALS } from "../../data/content";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];

  const prev = () => setI((p) => (p === 0 ? TESTIMONIALS.length - 1 : p - 1));
  const next = () => setI((p) => (p === TESTIMONIALS.length - 1 ? 0 : p + 1));

  return (
    <section
      data-testid="testimonials-section"
      className="py-24 sm:py-32"
      style={{ background: "var(--dl-elevated)" }}
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p
          className="section-eyebrow justify-center"
          style={{ justifyContent: "center", display: "inline-flex" }}
        >
          <span className="divider-rule" /> Guest Stories
        </p>

        <Quote
          size={36}
          className="mx-auto mt-10 mb-6"
          style={{ color: "var(--dl-accent)" }}
        />

        <blockquote
          data-testid={`testimonial-quote-${i}`}
          className="font-serif text-2xl sm:text-3xl lg:text-4xl leading-[1.25] tracking-tight"
          style={{ color: "var(--dl-ink)", fontWeight: 400, fontStyle: "italic" }}
        >
          “{t.quote}”
        </blockquote>

        <div className="mt-10 flex flex-col items-center gap-1">
          <p
            className="font-serif text-xl"
            style={{ color: "var(--dl-ink)" }}
            data-testid={`testimonial-name-${i}`}
          >
            — {t.name}
          </p>
          <p className="overline" data-testid={`testimonial-detail-${i}`}>
            {t.detail}
          </p>
        </div>

        <div className="mt-12 flex items-center justify-center gap-4">
          <button
            onClick={prev}
            data-testid="testimonial-prev"
            aria-label="Previous testimonial"
            className="w-12 h-12 border flex items-center justify-center transition-colors hover:bg-[color:var(--dl-ink)] hover:text-[color:var(--dl-bg)]"
            style={{ borderColor: "var(--dl-ink)", color: "var(--dl-ink)" }}
          >
            <ChevronLeft size={18} />
          </button>
          <span
            className="text-sm tracking-[0.25em]"
            style={{ color: "var(--dl-ink-2)" }}
            data-testid="testimonial-counter"
          >
            {String(i + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}
          </span>
          <button
            onClick={next}
            data-testid="testimonial-next"
            aria-label="Next testimonial"
            className="w-12 h-12 border flex items-center justify-center transition-colors hover:bg-[color:var(--dl-ink)] hover:text-[color:var(--dl-bg)]"
            style={{ borderColor: "var(--dl-ink)", color: "var(--dl-ink)" }}
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
